// extracted by mini-css-extract-plugin
module.exports = {"root":"capsule-card_root__eIyFK","image":"capsule-card_image__MxVhk"};